import React from 'react';
import {primaryBlack, primaryColor, primaryGrayDark} from "../../theme/theme";
import {Tag} from "@chakra-ui/react";
import {BongaTagProps} from "../../types/DataTypes";

const BongaTag = ({children,onClick}:BongaTagProps) => {
    return (
        <Tag
            fontSize={"xs"}
            cursor={"pointer"}
            borderRadius={"3px"}
            p={".1rem .5rem"}
            bg={"gray.200"}
            color={primaryBlack}
            onClick={onClick}
            _hover={{
                bg: primaryGrayDark,
                color: primaryColor
            }}
        >
            {children}
        </Tag>
    );
};

export default BongaTag;
